import React from 'react'

import NotificationSettingsModal from '../components/NotificationSettingsModal'
import useNotificationSettingsModal from '../hooks/useNotificationSettingsModal'

function withNotificationsModal<P>(WrappedComponent: React.ComponentType<P>) {
  const ComponentWithModal = (props: P) => {
    const { savedFilterIdParam, modalOpen, onModalClose } = useNotificationSettingsModal()

    return (
      <>
        {modalOpen && (
          <NotificationSettingsModal
            onClose={() => onModalClose()}
            savedFilterIdParam={savedFilterIdParam}
          />
        )}
        <WrappedComponent {...props} />
      </>
    )
  }

  return ComponentWithModal
}

export default withNotificationsModal
